export default __webpack_public_path__ + "static/media/11.f3b79273.webp";